import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { DataGridPro, GridActionsCellItem, koKR } from '@mui/x-data-grid-pro';
import {
  Panel,
  PanelGroup,
  PanelResizeHandle,
} from 'react-resizable-panels';
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Container,
  CssBaseline,
  Grid,
  IconButton,
  LinearProgress,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import {
  Add,
  Edit,
  Delete,
  KeyboardArrowDown,
  KeyboardArrowUp,
  Visibility,
  Remove,
} from '@mui/icons-material';
import {
  FormInputText,
} from "../form";
import {
  ConfirmDialog,
} from "../dialog";
import { StyledTooltip } from "../tooltip";
import {
  CustomNoRowsOverlay,
} from "../datagrid";
import {
  dateFormat,
} from "../../utils";

const theme = createTheme();

const GStructureReviewManagement = ({
}) => {
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [modify, setModify] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});

  const sessionUser = useSelector(state => state.session.sessionUser);

  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      
    };

    fetchData();
  }, [dispatch]);

  return (
    <ThemeProvider theme={theme}>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Container component="main" maxWidth="false">
        <CssBaseline />
        <Box sx={{ mt: 3 }}>
          <PanelGroup direction="horizontal" style={{ height: 'calc(100vh - 120px)' }}>
            {/* 좌측 영역 */}
            <Panel defaultSize={40} minSize={20} maxSize={80}>
              <Box sx={{ 
                height: '100%', 
                border: '1px solid #e0e0e0', 
                borderRadius: 1,
                p: 2,
                backgroundColor: '#fafafa',
                borderRight: 'none',
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0
              }}>
                <Typography variant="h6" gutterBottom>
                  구조 검토 안내
                </Typography>
                {/* 좌측 내용을 여기에 추가 */}
                <Box sx={{ mt: 2 }}>
                  <Typography variant="body2" color="text.secondary">
                    ...
                  </Typography>
                </Box>
              </Box>
            </Panel>
            
            {/* 스플릿바 */}
            <PanelResizeHandle style={{ width: '8px', backgroundColor: '#e0e0e0' }}>
              <Box
                sx={{
                  width: '2px',
                  height: '40px',
                  backgroundColor: '#757575',
                  borderRadius: '1px',
                  margin: 'auto',
                  marginTop: '50%',
                  transform: 'translateY(-50%)'
                }}
              />
            </PanelResizeHandle>
            
            {/* 우측 영역 - iframe */}
            <Panel defaultSize={60} minSize={20} maxSize={80}>
              <Box sx={{ 
                height: '100%', 
                border: '1px solid #e0e0e0', 
                borderRadius: 1,
                overflow: 'hidden',
                borderLeft: 'none',
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0
              }}>
                <iframe
                  src="https://apps.sommer-informatik.com/trosifol/glasglobal/"
                  title="Trosifol GlasGlobal"
                  style={{
                    width: '100%',
                    height: '100%',
                    border: 'none',
                    display: 'block'
                  }}
                  allow="fullscreen"
                />
              </Box>
            </Panel>
          </PanelGroup>
        </Box>
      </Container>
    </ThemeProvider>
  );
};

export default GStructureReviewManagement;
